export const BLOCK_COUNTRIES_COOKIE_NAME = 'isBlockCountry'
